var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-left lg:w-1/3 md:w-1/3 mt-8"},[_c('h1',{staticClass:"font-bold text-4xl text-amber-400"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"leading-7"},[_vm._v(_vm._s(_vm.desc))])])
}
var staticRenderFns = []

export { render, staticRenderFns }